import { PubSub } from '@instinet-analytics/core-lib';

export interface TimePointerState {
    x?: number;
    time?: number;
    className?: string;
}

export class TimePointer extends PubSub<TimePointerState> {}
